import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
Vue.use(VueRouter);

const routes = [
    // {
    //     path: "/",
    //     name: "login",
    //     component: () => import("../views/login/login.vue"),
    //     meta: {
    //         title: "依托单位登录"
    //     }
    // },
    {
        path: "/",
        redirect: "/index"
    },
    {
        path: "/login-register",
        name: "login-register",
        component: () => import("../views/login/login-register.vue"),
        meta: {
            title: "忘记密码"
        }
    },
    {
        path: "/auth-login",
        name: "auth-login",
        component: () => import("../views/login/auth-login.vue"),
        meta: {
            title: "统一身份认证登录"
        }
    },
    {
        path: "/", //根路径
        name: "home",
        meta: {
            title: "中关村高新技术企业bei认定管理"
        },
        component: () => import("../views/index.vue"), //主布局组件
        children: [
            {
                path: "index", //首页
                name: "index",
                component: () => import("../views/index/index.vue"),
                meta: {
                    title: "创新券企业端首页"
                }
            },
            {
                path: "user/sys/list", //实验室认定账号
                name: "user-sys-list",
                component: () => import("../views/user/sys.vue"),
                meta: {
                    title: "实验室认定账号"
                }
            },
            {
                path: "user/sys/edit", //实验室认定账号
                name: "user-sys-edit",
                component: () => import("../views/user/sys-edit.vue"),
                meta: {
                    title: "实验室认定账号"
                }
            },
            {
                path: "user/year-report/list", //年报账号
                name: "user-year-report-list",
                component: () => import("../views/user/year-report.vue"),
                meta: {
                    title: "年报账号"
                }
            },
            {
                path: "user/year-report-edit", //年报账号编辑
                name: "user-year-report-edit",
                component: () => import("../views/user/year-report-edit.vue"),
                meta: {
                    title: "年报账号"
                }
            },
            {
                path: "user/info", //实验室认定账号
                name: "user-info",
                component: () => import("../views/user/info.vue"),
                meta: {
                    title: "修改个人信息"
                }
            },
            {
                path: "user/contact-info",
                name: "user-contact-info",
                component: () => import("../views/user/contact-info.vue"),
                meta: {
                    title: "联系人信息"
                }
            },
            {
                path: "declare-check",
                name: "declare-check",
                component: () => import("../views/declare-check/index.vue"),
                meta: {
                    title: "实验室申报审核"
                },
                children: [
                    {
                        path: "list",
                        name: "declare-check-list",
                        component: () => import("../views/declare-check/list.vue"),
                        meta: {
                            title: "申报认定待审核"
                        }
                    },
                    {
                        path: "audit",
                        name: "declare-check-audit",
                        component: () => import("../views/declare-check/audit.vue"),
                        meta: {
                            title: "申报认定已审核"
                        }
                    }
                ]
            },

            {
                path: "research-check",
                name: "research-check",
                component: () => import("../views/research-check/index.vue"),
                meta: {
                    title: "布局方案审核"
                },
                children: [
                    {
                        path: "list",
                        name: "research-check-list",
                        component: () => import("../views/research-check/list.vue"),
                        meta: {
                            title: "布局方案待审核列表"
                        }
                    },
                    {
                        path: "audit",
                        name: "research-check-audit",
                        component: () => import("../views/research-check/audit.vue"),
                        meta: {
                            title: "布局方案已审核列表"
                        }
                    }
                ]
            },
            {
                path: "task-check",
                name: "task-check",
                component: () => import("../views/task-check/index.vue"),
                meta: {
                    title: "任务签订审核"
                },
                children: [
                    {
                        path: "list",
                        name: "task-check-list",
                        component: () => import("../views/task-check/list.vue"),
                        meta: {
                            title: "任务签订待审核"
                        }
                    },
                    {
                        path: "audit",
                        name: "task-check-audit",
                        component: () => import("../views/task-check/audit.vue"),
                        meta: {
                            title: "任务签订已审核"
                        }
                    }
                ]
            },
            {
                path: "info",
                component: () => import("../views/info/index.vue"),
                meta: {
                    title: "查看"
                },
                children: [
                    {
                        path: "research-view",
                        component: () => import("../views/info/research-view.vue"),
                        meta: {
                            title: "布局方案查看"
                        }
                    },
                    {
                        path: "declare-view",
                        component: () => import("../views/info/declare-view.vue"),
                        meta: {
                            title: "申报认定查看"
                        }
                    },
                    {
                        path: "task-view",
                        component: () => import("../views/info/task-view.vue"),
                        meta: {
                            title: "任务签订查看"
                        }
                    }
                ]
            },
            {
                path: "info-change",
                component: () => import("../views/info-change/index.vue"),
                meta: {
                    title: "变更报送"
                },
                children: [
                    {
                        path: "dept",
                        name: "info-change-dept",
                        component: () => import("../views/info-change/dept/index.vue"),
                        meta: {
                            title: "依托单位名称变更"
                        },
                        children: [
                            {
                                path: "list",
                                name: "info-change-list",
                                component: () => import("../views/info-change/dept/list.vue"),
                                meta: {
                                    title: "依托单位名称变更"
                                }
                            },
                            {
                                path: "edit",
                                name: "info-change-edit",
                                component: () => import("../views/info-change/dept/edit.vue"),
                                meta: {
                                    title: "依托单位名称变更"
                                }
                            },
                            {
                                path: "log",
                                name: "info-change-log",
                                component: () => import("../views/info-change/dept/list-log.vue"),
                                meta: {
                                    title: "变更记录"
                                }
                            }
                        ]
                    },
                    {
                        path: "lab-leader",
                        name: "info-change-lab-leader",
                        component: () => import("../views/info-change/lab-leader/index.vue"),
                        meta: {
                            title: "实验室主任变更"
                        },
                        children: [
                            {
                                path: "list",
                                name: "info-change-lab-leader-list",
                                component: () => import("../views/info-change/lab-leader/list.vue"),
                                meta: {
                                    title: "实验室主任变更"
                                }
                            },
                            {
                                path: "edit",
                                name: "info-change-lab-leader-edit",
                                component: () => import("../views/info-change/lab-leader/edit.vue"),
                                meta: {
                                    title: "实验室主任变更"
                                }
                            },
                            {
                                path: "log",
                                name: "info-change-lab-leader-list-log",
                                component: () => import("../views/info-change/lab-leader/list-log.vue"),
                                meta: {
                                    title: "变更记录"
                                }
                            }
                        ]
                    }
                ]
            },
            {
                path: "annual-report",
                name: "annual-report",
                component: () => import("../views/annual-report/index.vue"),
                meta: {
                    title: "实验室年报审核"
                }
            },
            {
                path: "annual-report/form",
                name: "annual-report-form",
                component: () => import("../views/annual-report/form.vue"),
                meta: {
                    title: "实验室年报审核表单"
                }
            },
            {
                path: "public-list",
                name: "public-list",
                component: () => import("../views/public-list/index.vue"),
                meta: {
                    title: "公示拟认定名单"
                }
            },
            {
                path: "notice-list",
                name: "notice-list",
                component: () => import("../views/notice-list/index.vue"),
                meta: {
                    title: "通知公告"
                }
            },
            {
                path: "innovation-voucher",
                name: "innovation-voucher",
                component: () => import("../views/innovation-voucher/index.vue"),
                meta: {
                    title: "创新券申请"
                }
            },
            {
                path: "innovation-voucher/commitment",
                name: "innovation-voucher-commitment",
                component: () => import("../views/innovation-voucher/commitment.vue"),
                meta: {
                    title: "创新券申领承诺书"
                }
            },
            {
                path: "innovation-voucher/apply",
                name: "innovation-voucher-apply",
                component: () => import("../views/innovation-voucher/apply.vue"),
                meta: {
                    title: "首都科技创新券申领"
                }
            },
            {
                path: "compute-voucher",
                name: "compute-voucher",
                component: () => import("../views/compute-voucher/index.vue"),
                meta: {
                    title: "算力创新券申请"
                }
            },
            {
                path: "compute-voucher/commitment",
                name: "compute-voucher-commitment",
                component: () => import("../views/compute-voucher/commitment.vue"),
                meta: {
                    title: "算力创新券申领承诺书"
                }
            },
            {
                path: "compute-voucher/apply",
                name: "compute-voucher-apply",
                component: () => import("../views/compute-voucher/apply.vue"),
                meta: {
                    title: "算力创新券申领"
                }
            },
            {
                path: "dangerous-chemicals",
                name: "dangerous-chemicals",
                component: () => import("../views/dangerous-chemicals/index.vue"),
                meta: {
                    title: "安全生产"
                }
            },
            {
                path: "task-sign",
                name: "task-sign",
                component: () => import("../views/task-sign/index.vue"),
                meta: {
                    title: "任务书签订"
                }
            }
        ]
    }
];

const router = new VueRouter({
    mode: "history",
    base: "/cxqComClient",
    routes
});

router.beforeEach(async (to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    if (!store.getters.token && to.name !== "login" && to.name !== "login-register" && to.name !== "auth-login") {
        next({ name: "auth-login" });
    } else {
        next();
    }
});

export default router;
